module.exports = __webpack_public_path__ + "static/img/Jayden-Nguyen.6a828d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jayden-Nguyen.jpg
// module id = +ijZ
// module chunks = 0